
/* Papillons magiques (systeme fourni par le client) */
/*!
 * Papillons magiques · overlay animé, à poser sur n'importe quelle vidéo ou section
 * Aucune dépendance. Images intégrées au fichier.
 *
 * Usage 1 (automatique) :
 *   <div style="position:relative"> ... ta vidéo ...
 *     <div data-butterflies data-count="5" data-mobile-count="3"></div>
 *   </div>
 *   <script src="butterflies.js" defer><\/script>
 *
 * Usage 2 (JS) :
 *   const stop = Butterflies.mount(document.querySelector('.hero'), { count: 5 })
 *   stop() // pour retirer
 *
 * Options (attributs data-* ou objet JS) :
 *   count (5), mobileCount (3), minSize (70), maxSize (150),
 *   sparkles (true), zIndex (5), glow (true)
 */
(function () {
  'use strict'

  var IMG = {
    left: (window.BLOOMI_A+'bloomi-94c0124ad3.webp'),
    right: (window.BLOOMI_A+'bloomi-60dd448e8a.webp'),
    body: (window.BLOOMI_A+'bloomi-6f290c5d8a.webp')
  }

  var CSS = '' +
    '.bfly-layer{position:absolute;inset:0;overflow:hidden;pointer-events:none}' +
    '.bfly-layer canvas{position:absolute;inset:0}' +
    '.bfly-wrap{position:absolute;left:0;top:0;will-change:transform;pointer-events:none}' +
    '.bfly-glow{filter:drop-shadow(0 0 10px rgba(90,170,255,.65)) drop-shadow(0 0 26px rgba(60,130,255,.35))}' +
    '.bfly{position:relative;perspective:520px}' +
    '.bfly-inner{position:absolute;inset:0;transform-style:preserve-3d;transform:rotateX(28deg)}' +
    '.bfly-wing{position:absolute;top:0;width:50%;height:100%;background-size:100% 100%;background-repeat:no-repeat;backface-visibility:visible}' +
    '.bfly-wing.l{left:0;transform-origin:100% 50%;animation:bfly-flap-l var(--flap) infinite cubic-bezier(.45,0,.35,1)}' +
    '.bfly-wing.r{right:0;transform-origin:0% 50%;animation:bfly-flap-r var(--flap) infinite cubic-bezier(.45,0,.35,1)}' +
    '.bfly-body{position:absolute;top:0;left:50%;width:9%;height:100%;transform:translateX(-50%) translateZ(1px);background-repeat:no-repeat;background-size:100% 100%}' +
    '.bfly[data-glide="1"] .bfly-wing{animation:none;transition:transform .5s ease-out}' +
    '.bfly[data-glide="1"] .bfly-wing.l{transform:rotateY(28deg)}' +
    '.bfly[data-glide="1"] .bfly-wing.r{transform:rotateY(-28deg)}' +
    '@keyframes bfly-flap-l{0%,100%{transform:rotateY(-8deg)}45%{transform:rotateY(74deg)}55%{transform:rotateY(74deg)}}' +
    '@keyframes bfly-flap-r{0%,100%{transform:rotateY(8deg)}45%{transform:rotateY(-74deg)}55%{transform:rotateY(-74deg)}}' +
    '@media (prefers-reduced-motion:reduce){.bfly-wing{animation:none!important}}'

  function injectCss() {
    if (document.getElementById('bfly-css')) return
    var s = document.createElement('style')
    s.id = 'bfly-css'
    s.textContent = CSS
    document.head.appendChild(s)
  }

  function rand(a, b) { return a + Math.random() * (b - a) }

  function mount(target, opts) {
    opts = opts || {}
    var o = {
      count: opts.count != null ? +opts.count : 5,
      mobileCount: opts.mobileCount != null ? +opts.mobileCount : 3,
      minSize: opts.minSize != null ? +opts.minSize : 70,
      maxSize: opts.maxSize != null ? +opts.maxSize : 150,
      sparkles: opts.sparkles !== false && opts.sparkles !== 'false',
      glow: opts.glow !== false && opts.glow !== 'false',
      zIndex: opts.zIndex != null ? +opts.zIndex : 5,
      staticCount: opts.staticCount != null ? +opts.staticCount : 0
    }
    injectCss()

    // si on monte sur l'élément data-butterflies lui-même, il devient le calque
    var root
    if (target.hasAttribute && target.hasAttribute('data-butterflies')) {
      root = target
      root.classList.add('bfly-layer')
    } else {
      if (getComputedStyle(target).position === 'static') target.style.position = 'relative'
      root = document.createElement('div')
      root.className = 'bfly-layer'
      target.appendChild(root)
    }
    root.setAttribute('aria-hidden', 'true')
    root.style.zIndex = o.zIndex

    var canvas = document.createElement('canvas')
    root.appendChild(canvas)
    var ctx = canvas.getContext('2d')
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    var dpr = Math.min(window.devicePixelRatio || 1, 2)
    var W = root.clientWidth, H = root.clientHeight

    function resize() {
      W = root.clientWidth; H = root.clientHeight
      canvas.width = W * dpr; canvas.height = H * dpr
      canvas.style.width = W + 'px'; canvas.style.height = H + 'px'
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0)
    }
    resize()
    window.addEventListener('resize', resize)

    var isMobile = W < 768
    var n = isMobile ? o.mobileCount : o.count
    var scale = isMobile ? 0.7 : 1
    var now0 = performance.now()
    var bfs = []

    for (var i = 0; i < n; i++) {
      var w = rand(o.minSize, o.maxSize) * scale
      var h = w * 0.8
      var wrap = document.createElement('div')
      wrap.className = 'bfly-wrap' + (o.glow ? ' bfly-glow' : '')
      var el = document.createElement('div')
      el.className = 'bfly'
      el.style.width = w + 'px'
      el.style.height = h + 'px'
      el.style.marginLeft = -w / 2 + 'px'
      el.style.marginTop = -h / 2 + 'px'
      el.style.setProperty('--flap', rand(0.32, 0.5).toFixed(2) + 's')
      el.innerHTML =
        '<div class="bfly-inner">' +
        '<div class="bfly-wing l" style="background-image:url(' + IMG.left + ')"></div>' +
        '<div class="bfly-wing r" style="background-image:url(' + IMG.right + ')"></div>' +
        '<div class="bfly-body" style="background-image:url(' + IMG.body + ')"></div>' +
        '</div>'
      var phase = '-' + rand(0, 1).toFixed(2) + 's' // même phase pour les 2 ailes
      var wings = el.querySelectorAll('.bfly-wing')
      for (var k = 0; k < wings.length; k++) wings[k].style.animationDelay = phase
      wrap.appendChild(el)
      root.appendChild(wrap)

      var baseSpeed = rand(55, 95) * (w / 110)
      var isStat = i < o.staticCount
      bfs.push({
        wrap: wrap, el: el, w: w, isStatic: isStat, staticDeg: rand(-14, 14),
        x: isStat ? (W * ((i + 1) / (o.staticCount + 1)) + rand(-W * 0.05, W * 0.05)) : rand(W * 0.12, W * 0.88),
        y: isStat ? (H * 0.5 + rand(-H * 0.14, H * 0.14)) : rand(H * 0.15, H * 0.85),
        angle: rand(0, Math.PI * 2),
        turn: 0, turnTarget: 0, nextTurnAt: now0,
        speed: baseSpeed, baseSpeed: baseSpeed,
        glideUntil: 0, nextGlideAt: now0 + rand(2000, 6000),
        bobPhase: rand(0, Math.PI * 2), sparkAcc: 0
      })
    }

    var sparks = []
    var last = performance.now()
    var raf = 0
    var visible = true

    // pause quand la section n'est pas à l'écran (perf)
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (e) {
      visible = e[0].isIntersecting
      if (visible && !raf) { last = performance.now(); raf = requestAnimationFrame(tick) }
    }) : null
    if (io) io.observe(root)

    function tick(now) {
      raf = 0
      if (!visible) return
      var dt = Math.min((now - last) / 1000, 0.05)
      last = now

      for (var i = 0; i < bfs.length; i++) {
        var b = bfs[i]
        if (!reduced && !b.isStatic) {
          if (now > b.nextTurnAt) {
            b.turnTarget = rand(-1.8, 1.8)
            b.nextTurnAt = now + rand(600, 1800)
          }
          var m = Math.max(b.w, 80)
          if (b.x < m || b.x > W - m || b.y < m || b.y > H - m) {
            var toC = Math.atan2(H / 2 - b.y, W / 2 - b.x)
            var diff = toC - b.angle
            diff = Math.atan2(Math.sin(diff), Math.cos(diff))
            b.turnTarget = (diff > 0 ? 1 : -1) * 2.6
          }
          b.turn += (b.turnTarget - b.turn) * Math.min(1, dt * 3)
          b.angle += b.turn * dt

          var gliding = now < b.glideUntil
          if (!gliding && now > b.nextGlideAt) {
            b.glideUntil = now + rand(700, 1500)
            b.nextGlideAt = b.glideUntil + rand(3000, 7000)
            b.el.setAttribute('data-glide', '1')
          } else if (!gliding && b.el.getAttribute('data-glide') === '1') {
            b.el.setAttribute('data-glide', '0')
          }
          var target = gliding ? b.baseSpeed * 0.65 : b.baseSpeed
          b.speed += (target - b.speed) * Math.min(1, dt * 2)
          b.x += Math.cos(b.angle) * b.speed * dt
          b.y += Math.sin(b.angle) * b.speed * dt
          b.bobPhase += dt * 7
        } else if (!reduced && b.isStatic) { b.bobPhase += dt * 2.4 }

        var bob = Math.sin(b.bobPhase) * (b.isStatic ? 2.5 : 4)
        var deg = b.isStatic ? b.staticDeg : (b.angle * 180) / Math.PI + 90
        b.wrap.style.transform = 'translate3d(' + b.x + 'px,' + (b.y + bob) + 'px,0) rotate(' + deg + 'deg)'

        if (o.sparkles && !reduced && !b.isStatic) {
          b.sparkAcc += dt
          while (b.sparkAcc > 0.045) {
            b.sparkAcc -= 0.045
            var back = b.angle + Math.PI
            var dist = b.w * 0.15
            sparks.push({
              x: b.x + Math.cos(back) * dist + rand(-b.w * 0.25, b.w * 0.25),
              y: b.y + Math.sin(back) * dist + rand(-b.w * 0.2, b.w * 0.2),
              vx: rand(-8, 8), vy: rand(6, 22),
              life: 0, max: rand(0.7, 1.5),
              r: rand(0.8, 2.2) * (b.w / 110),
              hue: rand(195, 225)
            })
          }
        }
      }

      ctx.clearRect(0, 0, W, H)
      ctx.globalCompositeOperation = 'lighter'
      for (var j = sparks.length - 1; j >= 0; j--) {
        var s = sparks[j]
        s.life += dt
        if (s.life >= s.max) { sparks.splice(j, 1); continue }
        s.x += s.vx * dt; s.y += s.vy * dt
        var t = s.life / s.max
        var alpha = (t < 0.15 ? t / 0.15 : 1 - (t - 0.15) / 0.85) * 0.9
        var tw = 0.6 + 0.4 * Math.sin(s.life * 30 + s.x)
        var r = s.r * (1 + t * 0.5)
        var g = ctx.createRadialGradient(s.x, s.y, 0, s.x, s.y, r * 5)
        g.addColorStop(0, 'hsla(' + s.hue + ',100%,92%,' + alpha * tw + ')')
        g.addColorStop(0.3, 'hsla(' + s.hue + ',100%,70%,' + alpha * 0.5 * tw + ')')
        g.addColorStop(1, 'hsla(' + s.hue + ',100%,60%,0)')
        ctx.fillStyle = g
        ctx.beginPath(); ctx.arc(s.x, s.y, r * 5, 0, Math.PI * 2); ctx.fill()
      }
      ctx.globalCompositeOperation = 'source-over'

      raf = requestAnimationFrame(tick)
    }
    raf = requestAnimationFrame(tick)

    return function destroy() {
      if (raf) cancelAnimationFrame(raf)
      if (io) io.disconnect()
      window.removeEventListener('resize', resize)
      if (root === target) { root.innerHTML = ''; root.classList.remove('bfly-layer') }
      else root.remove()
    }
  }

  function auto() {
    var els = document.querySelectorAll('[data-butterflies]')
    for (var i = 0; i < els.length; i++) {
      var el = els[i]
      if (el.__bfly) continue
      var d = el.dataset
      el.__bfly = mount(el, {
        count: d.count, mobileCount: d.mobileCount,
        minSize: d.minSize, maxSize: d.maxSize,
        sparkles: d.sparkles, glow: d.glow, zIndex: d.zIndex,
        staticCount: d.static
      })
    }
  }

  window.Butterflies = { mount: mount, init: auto }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', auto)
  else auto()
})()

